import { render, staticRenderFns } from "./WastenotificationitemsFormHeader.vue?vue&type=template&id=14319494"
import script from "./WastenotificationitemsFormHeader.vue?vue&type=script&lang=js"
export * from "./WastenotificationitemsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports